package org.gstechnovos.jexonplastech.sections.products.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ProductsGridContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.white)
            .padding(bottom = 100.px)
    }
}

val ProductCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .height(100.percent)
            .backgroundColor(palette.custom.white)
            .borderRadius(16.px)
            .border(1.px, LineStyle.Solid, palette.custom.lightGray)
            .overflow(Overflow.Hidden) // Ensures the image respects the rounded corners
            .transition(
                Transition.of("transform", 0.3.s),
                Transition.of("box-shadow", 0.3.s)
            )
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .translateY((-8).px)
            .boxShadow(0.px, 15.px, 30.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.1f))
    }
}

// ==========================================
// ANIMATIONS
// ==========================================
// Creates a smooth slide-up and fade-in effect for the cards
val CardAppearKeyframes = Keyframes {
    0.percent { Modifier.opacity(0).translateY(20.px) }
    100.percent { Modifier.opacity(1).translateY(0.px) }
}